
export default function Footer() {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    cursos: [
      { name: 'Todos los Cursos', path: '/cursos' },
      { name: 'Certificación Oficial', path: '/cursos#certificacion' },
      { name: 'Metodología', path: '/cursos#metodologia' }
    ],
    empresa: [
      { name: 'Sobre Nosotros', path: '/nosotros' },
      { name: 'Nuestro Equipo', path: '/nosotros#equipo' },
      { name: 'Valores', path: '/nosotros#valores' }
    ],
    soporte: [
      { name: 'Contacto', path: '/contacto' },
      { name: 'Preguntas Frecuentes', path: '/contacto#faqs' },
      { name: 'Términos y Condiciones', path: '/terminos' }
    ]
  };

  return (
    <footer className="bg-gradient-to-br from-primary-600 to-primary-800 text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div>
            <div className="flex items-center gap-3 mb-6">
              <img
                src="https://static.readdy.ai/image/1641cce445e23a33732a9af05560332a/4b755a8beaf3238abeae556b320a2b38.png"
                alt="AULA K9"
                className="w-36 h-36 object-contain"
              />
            </div>
            <p className="text-blue-100 leading-relaxed mb-6">
              Formación profesional en adiestramiento canino con certificación oficial. Excelencia educativa y compromiso con el bienestar animal.
            </p>
            <div className="flex gap-4">
              <a
                href="#"
                className="w-10 h-10 bg-secondary-600 rounded-full flex items-center justify-center hover:bg-secondary-500 transition-colors cursor-pointer"
                aria-label="Facebook"
              >
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-secondary-600 rounded-full flex items-center justify-center hover:bg-secondary-500 transition-colors cursor-pointer"
                aria-label="Instagram"
              >
                <i className="ri-instagram-fill text-xl"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-secondary-600 rounded-full flex items-center justify-center hover:bg-secondary-500 transition-colors cursor-pointer"
                aria-label="YouTube"
              >
                <i className="ri-youtube-fill text-xl"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-6">Cursos</h3>
            <ul className="space-y-3">
              {footerLinks.cursos.map((link, index) => (
                <li key={index}>
                  <a
                    href={link.path}
                    className="text-blue-100 hover:text-white transition-colors cursor-pointer"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-6">Empresa</h3>
            <ul className="space-y-3">
              {footerLinks.empresa.map((link, index) => (
                <li key={index}>
                  <a
                    href={link.path}
                    className="text-blue-100 hover:text-white transition-colors cursor-pointer"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-6">Contacto</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <i className="ri-mail-line text-xl text-secondary-300 flex-shrink-0 mt-1"></i>
                <a
                  href="mailto:info@aulak9.org"
                  className="text-blue-100 hover:text-white transition-colors cursor-pointer"
                >
                  info@aulak9.org
                </a>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-phone-line text-xl text-secondary-300 flex-shrink-0 mt-1"></i>
                <a
                  href="tel:+34722131257"
                  className="text-blue-100 hover:text-white transition-colors cursor-pointer"
                >
                  +34 722 131 257
                </a>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-map-pin-line text-xl text-secondary-300 flex-shrink-0 mt-1"></i>
                <span className="text-blue-100">
                  Navarra, España
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-primary-500 pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-blue-100 text-sm text-center md:text-left">
              © {currentYear} AULA K9 - Don Bandi El Taller de Pensar. Todos los derechos reservados.
            </p>
            <div className="flex items-center gap-4">
              <a
                href="/terminos"
                className="text-blue-100 hover:text-white text-sm transition-colors cursor-pointer"
              >
                Términos y Condiciones
              </a>
              <span className="text-blue-300">•</span>
              <a
                href="https://readdy.ai/?ref=logo"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-100 hover:text-white text-sm transition-colors cursor-pointer"
              >
                Website Builder
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
